import React, { useState } from 'react';
import classNames from 'classnames';
import MessageContent from './MessageContent';
import ThinkingIcon from '../ThinkingIcon/ThinkingIcon';
import styles from './ConversationPanel.module.css';
import { GenericSparkleIcon } from '../Icons/ToolCallIcons';

interface ReasoningProps {
  reasoning: string;
  hasContent: boolean;
}

const Reasoning: React.FC<ReasoningProps> = ({ reasoning, hasContent }) => {
  const [previewCollapsed, setPreviewCollapsed] = useState(true);

  const isStreaming = !hasContent;
  const reasoningTitle = isStreaming ? 'Planning...' : 'Planned';

  return (
    <div
      className={classNames(
        styles.toolCall,
        styles.toolCallClickable,
        styles.toolCallComplete,
        {
          [styles.toolCallCollapsed]: previewCollapsed,
          [styles.toolCallExpanded]: !previewCollapsed,
        }
      )}
      onClick={() => setPreviewCollapsed(!previewCollapsed)}
    >
      <div className={styles.toolCallHeader}>
        {isStreaming ? (
          <ThinkingIcon />
        ) : (
          <div className={styles.toolCallIcon}>
            <GenericSparkleIcon />
          </div>
        )}
        <div className={styles.toolCallPreviewTitle}>
          <MessageContent body={reasoningTitle} />
        </div>
        <div className={styles.toolCallStatusIcon}>
          <i
            className={classNames('fa fa-regular', {
              'fa-chevron-down': previewCollapsed,
              'fa-chevron-up': !previewCollapsed,
            })}
          />
        </div>
      </div>
      <div className={classNames(styles.toolCallContent)}>
        <MessageContent body={reasoning} contentType={'text/markdown'} />
      </div>
    </div>
  );
};

export default Reasoning;
